// types for UI
export var ThemeType;
(function (ThemeType) {
    ThemeType["ZURICH"] = "zurich";
    ThemeType["ZC"] = "zc";
})(ThemeType || (ThemeType = {}));
